import {
  Component,
  ChangeDetectionStrategy,
  AfterViewInit,
  OnInit,
  ElementRef,
  inject,
  input,
  booleanAttribute,
} from '@angular/core';
import { LoadingComponent } from '@cue/loading';
import { ProgressiveImagePlaceholderDirective } from '../../directives/progressive-image-placeholder.directive';
import { ProgressiveImageDirective } from '../../directives/progressive-image.directive';
import { ProgressiveImageComponent } from '../progressive-image/progressive-image.component';
import { DisableRightClickDirective, ImageDimensionsPipe } from '@cue/utilities';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'cue-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LoadingComponent,
    ProgressiveImageDirective,
    ProgressiveImagePlaceholderDirective,
    ProgressiveImageComponent,
    ImageDimensionsPipe,
    DisableRightClickDirective,
    NgStyle,
  ],
})
export class ImageComponent implements OnInit, AfterViewInit {
  src = input(null);
  imageClass = input('');
  loadWidth = input<number | 'auto'>();
  loadHeight = input<number>();
  imgHeight = input('auto');
  imgWidth = input('100%');
  imgMaxHeight = input<string>();
  imgMaxWidth = input('50px');
  cover = input(false);
  objectPosition = input('center center');

  preventContextMenu = input<boolean, boolean | 'true' | 'false'>(false, {
    transform: booleanAttribute,
  });
  private readonly elRef = inject(ElementRef);

  width?: number | 'auto';

  ngOnInit() {
    if (this.loadWidth() !== 'auto' && this.loadWidth()) {
      this.width = this.loadWidth();
    }
  }

  ngAfterViewInit() {
    if (this.loadWidth() === 'auto') {
      this.width = this.elRef.nativeElement.clientWidth;
    }
  }
}
